export const Ta_Reschedule_Table_Head = [
  { field: "sl_no", headerName: "Sl No", width: 100 },
  { field: "lead_name", headerName: "Student Name", width: 200 },
  { field: "lead_mob_no", headerName: "Phone Number", width: 200 },
  { field: "session_date", headerName: "Session Date", width: 250 },
  { field: "from_time", headerName: "From Time", width: 150 },
  { field: "to_time", headerName: "To Time", width: 150 },
  {
    field: "rescheduled_reason",
    headerName: "Rescheduled Reason",
    width: 200,
  },
  {
    field: "rescheduled_date",
    headerName: "Rescheduled Date",
    width: 200,
  },
  {
    field: "rescheduled_from_time",
    headerName: "From Time",
    width: 200,
  },
  {
    field: "rescheduled_to_time",
    headerName: "To Time",
    width: 200,
  },
];
